export const SENTRY_DSN = "https://bd31d7912de9792658a0e24502202be5@o522659.ingest.sentry.io/4506060297732096"
